import { FC } from "react";
import { Done } from "src/icons/Done";
import { Box } from "@otrium/core";
import { useTheme, Theme } from "@emotion/react";
import { Divider } from "src/atoms/Divider";
import { Locale } from "src/lib/Intl";
import { TrustpilotCustom } from "src/molecules/TrustpilotBox";
import styles from "./Footer.module.scss";
import { useMiscellaneous } from "src/hooks/useMiscellaneous";
import NoSSR from "src/atoms/NoSSR";
import { BCorpLogo } from "src/atoms/BCorpLogo/BCorpLogo";

interface Props {
  locale: Locale;
}

export const FooterFeatures: FC<Props> = ({ locale }) => {
  const theme: Theme = useTheme();
  const { data: miscellaneousData } = useMiscellaneous();

  const footerOffers = miscellaneousData?.miscellaneous?.footer ?? [];

  return (
    <div className={styles.featuresWrapper}>
      <Box mb={"23px"}>
        <Divider color={theme.colors.tone.anthraciteDark} />
      </Box>
      <ul className={styles.featuresList} aria-label="Our advantages">
        {footerOffers.map((footer, index) => (
          <li key={index}>
            <NoSSR>
              <Done role="presentation" />
            </NoSSR>
            <span>{footer}</span>
          </li>
        ))}
        <li className={styles.trustpilot}>
          <TrustpilotCustom locale={locale} />
        </li>
        <li>
          <BCorpLogo locale={locale} />
        </li>
      </ul>
    </div>
  );
};
